import $ from 'jquery';
import classnames from 'consts/classnames';

/**
 * * @returns {void}
 */
const dropdowns = () => {
    const { DROPDOWN_IS_OPEN, IS_EXPANDED } = classnames;

    const TOGGLER_CLASSNAME = 'js-dropdown-toggler';

    addClickEventToBody();

    /**
     * check if element is event target
     * @param {HTMLElement} element
     * @param {HTMLElement} eTarget event target
     * * @returns {boolean}
     */
    function elementIsEventTarget(element, eTarget) {
        if (!element) {
            return false;
        }

        return element === eTarget || element.contains(eTarget);
    }

    /**
     * * @returns {void}
     */
    function addClickEventToBody() {
        const { body } = document;

        // we will attach new body listeners once the HTML is updated via Update Panel
        body.removeEventListener('click', clickHandler);
        body.addEventListener('click', clickHandler);
    }

    /**
     * @typedef ExpandedElements
     * @type {Object}
     * @property {HTMLElement} openDropdown
     * @property {HTMLElement} expandedToggler
     */

    /**
     * @returns {ExpandedElements}
     */
    function getExpandedElements() {
        const openDropdown = document.querySelector(`.${DROPDOWN_IS_OPEN}`);

        const expandedToggler = document.querySelector(
            `.${TOGGLER_CLASSNAME}.${IS_EXPANDED}`
        );

        return {
            openDropdown,
            expandedToggler
        };
    }

    /**
     * @param {MouseEvent} event
     * * @returns {void}
     */
    function clickHandler(event) {
        const { target } = event;
        const { openDropdown } = getExpandedElements();
        const closestElement = target.closest(`.${TOGGLER_CLASSNAME}`);
        const isOutSideClick = !elementIsEventTarget(openDropdown, target);

        if (closestElement) {
            toggleDropdown(closestElement);
            return;
        }

        if (isOutSideClick) {
            outSideClick();
        }
    }

    /**
     * @param {HTMLElement} toggler
     * * @returns {void}
     */
    function toggleDropdown(toggler) {
        const target = document.querySelector(
            `.${toggler.dataset.toggleTarget}`
        );

        if (!target) {
            return;
        }

        const { openDropdown, expandedToggler } = getExpandedElements();

        if (!target.classList.contains(DROPDOWN_IS_OPEN)) {
            if (openDropdown) {
                openDropdown.setAttribute('aria-hidden', 'true');
                openDropdown.classList.remove(DROPDOWN_IS_OPEN);
            }

            if (expandedToggler) {
                expandedToggler.setAttribute('aria-expanded', 'false');
                expandedToggler.classList.remove(IS_EXPANDED);
            }

            toggler.setAttribute('aria-expanded', 'true');
            toggler.classList.add(IS_EXPANDED);
            target.classList.add(DROPDOWN_IS_OPEN);
            target.setAttribute('aria-hidden', 'false');

            return;
        }

        toggler.setAttribute('aria-expanded', 'false');
        toggler.classList.remove(IS_EXPANDED);
        target.classList.remove(DROPDOWN_IS_OPEN);
        target.setAttribute('aria-hidden', 'true');
    }

    /**
     * * @returns {void}
     */
    function outSideClick() {
        const { openDropdown, expandedToggler } = getExpandedElements();

        if (!openDropdown || !expandedToggler) {
            return;
        }

        openDropdown.classList.remove(DROPDOWN_IS_OPEN);
        openDropdown.setAttribute('aria-hidden', 'true');
        expandedToggler.setAttribute('aria-expanded', 'false');
        expandedToggler.classList.remove(IS_EXPANDED);
    }
};

$(() => {
    dropdowns();
});
